import { Button, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/system';
import { IChatConversation } from 'src/@types/chat';
import Iconify from 'src/components/iconify';
import { useLocales } from 'src/locales';
import { useChatConversationContext } from 'src/sections/@dashboard/chat/ChatConversation/useChatConversationContext';
import {
  ChatDetailsTitle,
  useChatDetailsDialog,
} from 'src/sections/@dashboard/chat/shared/ChatOverviewDialog';
import { StyledChatInitialStateContainer } from './styles';

export const ChannelIcon = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.divider}`,
  fontSize: '2rem',
  lineHeight: 1,
  color: theme.palette.primary.main,
  width: theme.spacing(6),
  height: theme.spacing(6),
}));

type Props = {
  conversation: IChatConversation;
};

export const TextInitialState = ({ conversation }: Props) => {
  const theme = useTheme();
  const { translate } = useLocales();
  const { userPermissions } = useChatConversationContext();

  const { showChatDetailsDialog } = useChatDetailsDialog();
  const handleShowDetails = (tab?: ChatDetailsTitle) => {
    showChatDetailsDialog({ conversationId: conversation._id, tab });
  };

  return (
    <StyledChatInitialStateContainer>
      <ChannelIcon>#</ChannelIcon>
      <Typography variant="h4">
        {translate('communicate.text_initial_state.welcome_msg', {
          conversationName: conversation.name,
        })}
      </Typography>
      <Stack
        direction="row"
        alignItems="center"
        color="text.secondary"
        gap={0.5}
      >
        <Typography>
          {translate('communicate.text_initial_state.this_is_the_beginning')}
        </Typography>
        <Typography variant="subtitle1">#{conversation.name}</Typography>
        <Typography>{`${translate('shared.labels.channel')}.`}</Typography>
      </Stack>
      {!userPermissions.canEditChannel && !userPermissions.manageMembers && (
        <Stack direction="row" alignItems="center" gap={1.5}>
          <Button
            variant="outlined"
            sx={{
              borderColor: theme.palette.divider,
              color: theme.palette.text.primary,
            }}
            startIcon={<Iconify icon="tabler:users-plus" />}
            onClick={() => handleShowDetails(ChatDetailsTitle.MEMBERS)}
          >
            {translate('shared.buttons.add_member')}
          </Button>
          <Button
            variant="outlined"
            sx={{
              borderColor: theme.palette.divider,
              color: theme.palette.text.primary,
            }}
            startIcon={<Iconify icon="tabler:pencil" />}
            onClick={() => handleShowDetails(ChatDetailsTitle.OVERVIEW)}
          >
            {translate('shared.buttons.edit_channel')}
          </Button>
        </Stack>
      )}
    </StyledChatInitialStateContainer>
  );
};
